import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { getApiErrorMessage } from "~/api/apiError";
import { useToast } from "~/components/ui/use-toast";

import { ApiClient } from "../api-client";
import { serverCartQueryOptions } from "../queries/useServerCart";
import { queryClient } from "../queryClient";

export function useRemoveFromServerCart() {
  const { toast } = useToast();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: async (courseId: string) => {
      const response = await ApiClient.instance.delete(`/api/cart/items/${courseId}`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(serverCartQueryOptions);
    },
    onError: (error) => {
      toast({
        variant: "destructive",
        description: getApiErrorMessage(error, t("cart.errors.removeFailed")),
      });
    },
  });
}
